import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "preview", "container"]

    declare inputTarget: HTMLInputElement
    declare previewTarget: HTMLImageElement
    declare containerTarget: HTMLElement

    preview() {
        const input = this.inputTarget
        const preview = this.previewTarget
        const container = this.containerTarget

        if (input.files && input.files[0]) {
            const reader = new FileReader()

            reader.onload = (e: Event) => {
                const result = (e.target as FileReader).result
                if (result) {
                    preview.src = result.toString()
                    container.classList.remove("hidden")
                }
            }

            reader.readAsDataURL(input.files[0])
        }
    }
}
